import { Button, type ButtonProps } from '@progress/kendo-react-buttons'
import React from 'react'

import {
  getButtonClassName,
  type StyledButtonCommonProps,
} from '~/components/common/StyledButton'

export type StyledButtonProps = ButtonProps &
  StyledButtonCommonProps & {
    'data-testid'?: string
  }

export const StyledButton = (props: StyledButtonProps) => {
  const {
    buttonStyle: _buttonStyle,
    children,
    className: _className,
    'data-testid': dataTestId = 'components-elements-styled-button',
    noPadding: _noPadding,
    ...rest
  } = props

  return (
    <Button
      className={getButtonClassName(props)}
      data-testid={dataTestId}
      {...rest}
    >
      {children}
    </Button>
  )
}
